import { Button } from '@radix-ui/themes';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { MachineContext, MachineDialogMode } from 'contexts/machine.context';
import { t } from 'i18next';
import { DataCollectionType } from 'lib_ts/enums/data-collection.enums';
import { InstallStep } from 'lib_ts/enums/installation';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext, useState } from 'react';
import { useAuthStore } from 'stores/use-auth-store';

export const CalibrateBallButton = () => {
  const [creatingDc, setCreatingDc] = useState(false);

  const current = useAuthStore((s) => s.current);

  const {
    machine,
    openDialog: machineCxOpenDialog,
    createDataCollection,
    update: updateMachine,
  } = useContext(MachineContext);

  const isInstalling =
    machine.last_installation && !machine.last_installation.end_date;

  return (
    <Button
      color={RADIX.COLOR.WARNING}
      loading={creatingDc}
      onClick={async () => {
        // overwrite the machine last_installation and open the dialog
        if (!isInstalling) {
          setCreatingDc(true);
          const newDc = await createDataCollection(
            DataCollectionType.BallTypeCalibration,
            machine.machineID,
            machine.ball_type
          );

          if (!newDc) {
            setCreatingDc(false);
            return;
          }

          await updateMachine({
            _id: machine._id,
            last_installation: {
              standalone: InstallStep.BallType,
              started_by: current.email,
              start_date: new Date().toISOString(),
              ball_type: machine.ball_type,
              ball_type_locked: true,
              btcID: newDc._id,

              end_date: null,
              finished_by: null,
              model_id: null,
              rtID: null,

              step_ball_type: null,
              step_completion: null,
              step_general_config: null,
              step_hardware_changes: null,
              step_projector_config: null,
              step_repeatability: null,
              step_test_shot: null,
              step_vision: null,

              vccID: null,
              vcdFt: null,
              vcdComplete: null,
            },
          });

          machineCxOpenDialog(MachineDialogMode.Installation);
          setCreatingDc(false);

          return;
        }

        // * install is in progress
        const { last_installation } = machine;

        if (!last_installation) {
          // shouldn't trigger but makes TS happy
          return;
        }

        // if standalone BTC and for the current ball type, treat this as a resume
        if (
          last_installation.standalone === InstallStep.BallType &&
          last_installation.ball_type === machine.ball_type
        ) {
          machineCxOpenDialog(MachineDialogMode.Installation);
          return;
        }

        // show a toast instead
        NotifyHelper.warning({
          message_md: `Please complete or cancel the installation for ${last_installation.ball_type} before trying again.`,
        });
      }}
      className="btn-block text-titlecase"
    >
      {t('common.calibrate-ball-type')}
    </Button>
  );
};
